import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Languages } from 'lucide-react';

interface LanguageSwitcherProps {
  compact?: boolean;
  className?: string;
}

export default function LanguageSwitcher({ compact = false, className = '' }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  const toggle = () => {
    const newLang = isArabic ? 'en' : 'ar';
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
  };

  if (compact) {
    return (
      <Button variant="ghost" size="sm" onClick={toggle} className={`gap-1.5 ${className}`}>
        <Languages className="h-4 w-4" />
        {isArabic ? 'EN' : 'عربي'}
      </Button>
    );
  }

  return (
    <Button variant="outline" size="sm" onClick={toggle} className={`gap-2 ${className}`}>
      <Languages className="h-4 w-4" />
      {isArabic ? 'English' : 'العربية'}
    </Button>
  );
}
